import { Dispatch, SetStateAction } from 'react';
import { ace_index } from '@axo/shared/data-access/types';
import { FilterSelect } from '../FilterSelect';
import { areObjectsDifferent } from '../../utils/compareObjects';
import { setPageNumber } from '../SearchResults';

interface Props {
  query: ace_index.FindInput;
  setQuery: Dispatch<SetStateAction<ace_index.FindInput>>;
  editable?: boolean;
}

export function NumNotAnsweredCallsBetween({
  query,
  setQuery,
  editable = false,
}: Props) {
  const state = getNumNotAnsweredCalls(query);
  const value =
    options.find((option) => !areObjectsDifferent(state, option.value)) ??
    options[0];

  return (
    <FilterSelect
      items={options}
      onSelect={(option) => setQuery(setNumNotAnsweredCalls(option.value))}
      stringify={(option) => option.label}
      value={value}
      label="Called with no answer"
      description={
        <span>
          Filter applications by how many <em>un</em>answered calls have been
          made
        </span>
      }
      disabled={!editable}
    />
  );
}

const options: { label: string; value: Value }[] = [
  {
    label: 'All',
    value: undefined,
  },
  {
    label: 'Yes',
    value: {
      From: 1,
    },
  },
  {
    label: 'No',
    value: {
      From: 0,
      To: 1,
    },
  },
];

function setNumNotAnsweredCalls(
  range: Value
): SetStateAction<ace_index.FindInput> {
  return (query) => ({
    ...setPageNumber(1)(query),
    SummaryNumNotAnsweredCalls: range,
  });
}

function getNumNotAnsweredCalls(query: ace_index.FindInput) {
  return query.SummaryNumNotAnsweredCalls;
}

type Value = ace_index.FindInput['SummaryNumNotAnsweredCalls'];
